'use strict'

import { initialiseElement as initScrollerElement } from '../modules/scroller';
import { isLoggedIn } from '../utils/cookies';
import { loadComponent } from './utils/load-component';

loadComponent(
    'calendar-popup',
    {
        props: [],
        data: function () {
            return {
                ViewModel: {
                    Performances: [],
                    LoggedIn: isLoggedIn(),
                }
            };
        },

        beforeMount: function () {
            this.$root.$on('CalendarPopup.scrollToPerformance', this.scrollToPerformance);
            this.$root.$on('CalendarPopup.updatePerformances', this.updatePerformances);
        },

        mounted: function () {
            this.Swiper = initScrollerElement(this.$el);
        },

        methods: {
            updatePerformances: function (perfs) {
                this.ViewModel.Performances = perfs;
            },
            scrollToPerformance: function (perf) {
                const index = this.ViewModel.Performances.findIndex(testPerf => {
                    return perf.id === testPerf.id;
                });
                setTimeout(() => {
                    this.Swiper.slideTo(index);
                });
            },
        },
    }
)
